function init() {
    if (typeof (Storage) !== "undefined") {
        sessionStorage.clear();
    }
}

export const accountPrograms = {
    init: init
};
